export default __webpack_public_path__ + "static/media/GreenIndicator2.4057f5cc.svg";